import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-agreements',
    templateUrl: './agreements.component.html',
    styleUrls: ['./agreements.component.scss'],
})
export class AgreementsComponent implements OnInit {
    public isLoading = true;

    constructor(private readonly route: ActivatedRoute) {}

    ngOnInit() {
        let agreement = this.route.snapshot.paramMap.get('agreement');
        if (agreement.toLocaleLowerCase().includes('enduseragreement')) {
            window.location.replace('agreements/EndUserAgreement.pdf');
            agreement = 'EndUserAgreement.pdf';
        }
        if (!agreement.endsWith('.pdf')) {
            window.location.replace(`agreements/${agreement}.pdf`);
            agreement += '.pdf';
        }

        // If we get to this point with a document it means that PDF did not exist

        // Only display the message if the user is not redirected
        setTimeout(() => {
            this.isLoading = false;
        }, 2000);
    }
}
